// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0074aeaf","732":"984734da","977":"9d9cedb9"}[chunkId] + ".chunk.js";
};